$.fn.isInViewport = function (top) {
    if ($(window).width() < 992) top = 0;
    var elementTop = $(this).offset()?.top + Number(top);
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    //return elementBottom > viewportTop &&
    return elementTop < viewportBottom;
  };
  $(window).on('resize scroll load', function () {
    $('.animate__animated').each(function (index, element) {
      const top = $(this).data("top") || 0;
      if ($(this).isInViewport(top)) {
        const type = $(this).data("type");
        const duration = $(this).data("duration") || "800ms";
        let delay = $(this).data("delay") || "0";
        const delayMobile = $(this).data("delay-mobile");
        if ($(window).width() < 992 && delayMobile != undefined) delay = delayMobile;

        if ($(this).hasClass(type)) return;
        $(this).css("visibility", "visible")
        this.style.setProperty(`--animate-duration`, duration);
        this.style.setProperty(`--animate-delay`, delay);
        $(this).addClass(type)
      } else {
        // do something else
        // $(this).
      }
    })

  });
